<template>
  <van-swipe @change="onChange" :autoplay="3000" v-if="safeLst">
    <van-swipe-item v-for="(item, index) in safeLst" :key="index">
      <div class="banner-item">
        <img v-lazy="item.img" class="banner_img" />
        <div class="item-text">
          {{ item.text }}
        </div>
      </div>
    </van-swipe-item>
    <template #indicator>
      <div class="custom-indicator">
        <div
          class="point"
          :class="current == item ? 'show-point' : ''"
          v-for="item in safeLst.length"
          :key="item"
        />
      </div>
    </template>
  </van-swipe>
</template>

<script>
export default {
  name: 'DiscountBannerSwipeView',
  props: ['lst'],
  computed: {
    safeLst () {
      return this.lst || null
    }
  },
  data () {
    return {
      current: 1
    }
  },
  methods: {
    onChange (index) {
      this.current = index + 1
    }
  }
}
</script>
<style lang="scss" scoped>
.banner_img {
  width: 100%;
  height: calc(100vw * 108 / 97);
  object-fit: cover;

}
  .banner-item {
    width: 100%;
    height: 100%;
    position: relative;
    .item-text {
      position: absolute;
      width: calc(100% - 20px);
      padding: 10px 10px 20px 10px;
      line-height: 1.8;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 1;
      left: 0px;
      bottom: 0px;
      color: #fff;
    }
  }
.custom-indicator {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 6px 8px;
  display: flex;
  gap: 8px;
  .point {
    width: 8px;
    height: 8px;
    background: gray;
    border-radius: 50%;
  }
  .show-point {
    background: #fff !important;
  }
}
</style>
